import { gql } from '@apollo/client';

const UNSUBSCRIBE_NOTIFICATION = gql`
  mutation unsubscribeNotification($savedNotificationId: Int!) {
    unsubscribeNotification(savedNotificationId: $savedNotificationId)
  }
`;

export default UNSUBSCRIBE_NOTIFICATION;
